import React from "react";
import { Page } from "@/components/Layout";
import FlipCards from "@/components/FlipCards";
import Seo from "@/components/Seo";
import TestimonialCarousel from "@/components/TestimonialCarousel";
import ArticlesCarousel from "@/components/ArticlesCarousel";
import InstagramCarousel from "@/components/InstagramCarousel";
import HomeWhoHereForSection from "@/pages/home/HomeWhoHereForSection";
import HomeAsSeenOnSection from "@/pages/home/HomeAsSeenOnSection";
import HomeEcosystemSection from "@/pages/home/HomeEcosystemSection";
import HomeHowWeWorkSection from "@/pages/home/HomeHowWeWorkSection";
import HomeFindYourPathSection from "@/pages/home/HomeFindYourPathSection";
import HomeBrainHealthSection from "@/pages/home/HomeBrainHealthSection";

export default function Home() {
  return (
    <Page>
      <Seo title="Home" description="Become Your Own Brain-Manager. Therapy, cognitive support and psychology mentorship at MindDhara." />

      {/* FULL-WIDTH HERO SLIDER */}
      <FlipCards />

      {/* WHO ARE YOU HERE FOR */}
      <HomeWhoHereForSection />

      {/* AS SEEN ON */}
      <HomeAsSeenOnSection />

      {/* THREE-ARM ECOSYSTEM */}
      <HomeEcosystemSection />

      {/* HOW WE WORK */}
      <HomeHowWeWorkSection />

      {/* FIND YOUR PATH */}
      <HomeFindYourPathSection />

      {/* JOIN OUR COMMUNITY, Instagram carousel (renders only if admin has added posts) */}
      <InstagramCarousel />

      {/* BRAIN HEALTH + STATS */}
      <HomeBrainHealthSection />

      {/* TESTIMONIALS CAROUSEL */}
      <TestimonialCarousel />

      {/* ARTICLES CAROUSEL, last section */}
      <ArticlesCarousel />
    </Page>
  );
}
